import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from "axios";
import moment from "moment";
import apiClient from "../apiClient/index.js"
import { EXLDownloadIcon, LeftArrow, PDFDownloadIcon, UpDownIcon } from "../Assets/iconshere";
import { humanReadable } from "../utils/useWindowDimensions";
import { exportMultipleChartsToPdf, generateExcel } from "../utils/pdf";
import Skeleton from "react-loading-skeleton";
import DateRangeFilter from "./DateRangeFilter";
import UserEngagementTable from "./UserEngagementTable";

const UserEngagement = () => {
  const userData = useSelector((state) => state.userSlice);
  const configData = useSelector((state) => state.configSlice);
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;
  const queryParams = new URLSearchParams(location.search);
  const type = queryParams.get("type");
  const { uuid } = useParams();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalTimeSpent, setTotalTimeSpent] = useState(0);
  const [averageTimeSpent, setAverageTimeSpent] = useState(0);
  const [totalEventTimeSpent, setTotalEventTimeSpent] = useState(0);
  const [averageEventTimeSpent, setAverageEventTimeSpent] = useState(0);
  const [totalEvents, setTotalEvents] = useState(0);
  const [sortBy, setSortBy] = useState(null);
  const [dates, setDates] = useState({
    start: null,
    end: null,
  });

  const [totalPages, setTotalPages] = useState(0);
  const [page, setPage] = useState(0);
  const limit = 15;

  const getSessionData = async (page, limit) => {
    setLoading(true);
    try {

      const data = await apiClient.post(`${configData.config.API_URL}/api/dashboard/user-table/visits/${uuid}`, { dates, page, limit })

      setTotalTimeSpent(humanReadable(data.toatalSpentTime));
      setAverageTimeSpent(humanReadable(data.toatalSpentTime / data.count));
      setTotalPages(Math.min(data.count));
      setList(data.sessions);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const getEventData = async (page, limit) => {
    setLoading(true);
    try {

      const data = await apiClient.post(`${configData.config.API_URL}/api/dashboard/user-table/events/${uuid}`, { dates, page, limit })

      setAverageEventTimeSpent(data.totalSpentTime / data.allEvents.length);
      setTotalEventTimeSpent(humanReadable(data.totalSpentTime));
      setTotalEvents(data.allEvents.length);
      setList(data.allEvents);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const pdfData1 = [
    ["Group Name", state?.name || ""],
    ["Report Generated at :", moment().format("ll")],
  ];

  const generateDownloadData = async (type, fileType) => {
    try {
      let response;
      if (type === "visits" || type === "session") {
        response = await apiClient.post(`${configData.config.API_URL}/api/dashboard/user-table/visits`, { dates })

      }
      if (type === "eventsList" || type === "eventDuration") {
        response = await apiClient.post(`${configData.config.API_URL}/api/dashboard/user-table/events`, { dates })

      }

      if (type === "visits" || type === "session") {
        const pdfData = [["SL No.", "Timestamp", "Platform", "Time Spent"]];

        response.sessions.forEach((e, index) => {
          const startTime = new Date(e.startTime);
          const endTime = new Date(e.endTime);

          const timeDifferenceMs = endTime - startTime;
          const timeDifferenceSeconds = timeDifferenceMs / 1000;
          const timeDifferenceReadable = humanReadable(timeDifferenceSeconds);

          const rowData = [index + 1, e.createdAt, e.platform, timeDifferenceReadable];
          pdfData.push(rowData);
        });
        if (fileType === "pdf") exportMultipleChartsToPdf(type, pdfData1, pdfData);
        if (fileType === "excel") generateExcel(type, pdfData1, pdfData);
      }
      if (type === "eventsList" || type === "eventDuration") {
        const pdfData = [
          ["SL No.", "Event Name", "Event Environment", "Event Date", "Scheduled Duration", "Actual Duration"],
        ];

        response.allEvents.forEach((e, index) => {
          const rowData = [
            index + 1,
            e.eventName,
            e.environmentName,
            moment(e.date).format("LLL"),
            humanReadable(e.actualEventTime),
            humanReadable(e.activityDuration),
          ];
          pdfData.push(rowData);
        });
        if (fileType === "pdf") exportMultipleChartsToPdf(type, pdfData1, pdfData);
        if (fileType === "excel") generateExcel(type, pdfData1, pdfData);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (type === "visits" || type === "session") {
      getSessionData(page, limit);
    }
    if (type === "eventsList" || type === "eventDuration") {
      getEventData(page, limit);
    }
  }, [page, dates]);

  return (
    <>
      <div className="container-fluid bg-grey-main dashboard pt-2 px-3">
        <div className="container-fluid">
          <div className="row back-n-down">
            <div className="col-md-6 d-flex align-items-center">
              <button onClick={() => navigate(-1)} className="mb-0 ms-1 backbtn cursor-pointer " title="Back">
                <LeftArrow />
                Back
              </button>
            </div>
            <div className="col-md-6 d-flex align-items-center justify-content-end gap-2">
              {sortBy && (
                <button
                  className="DefaultRedBtn"
                  onClick={() => {
                    type === "visits" || type === "session" ? getSessionData(page, limit) : getEventData(page, limit);
                    setSortBy(null);
                  }}
                >
                  Clear Sorting <UpDownIcon />
                </button>
              )}
              <DateRangeFilter dates={dates} setDates={setDates} />
              <button
                className="DefaultRedBtn download"
                title="Download PDF"
                onClick={() => generateDownloadData(type, "pdf")}
              >
                <PDFDownloadIcon />
              </button>
              <button
                className="DefaultRedBtn download"
                title="Download Excel"
                onClick={() => generateDownloadData(type, "excel")}
              >
                <EXLDownloadIcon />
              </button>
            </div>
          </div>

          <div className="datacardesign " style={{ backgroundColor: "transparent" }}>
            <div className="row" style={{ backgroundColor: "#fff", borderRadius: "10px" }}>
              <div className="col-md-5 d-flex align-itmes-center ">
                <div className="cardimages d-flex align-items-center gap-3 ps-2">
                  {loading ? (
                    <span className="m-2">
                      <Skeleton count={1} circle height="4.5vw" width="4.5vw" className="pb-2" />
                    </span>
                  ) : (
                    <>
                      {state?.avatar?.length > 0 ? (
                        <div className="groupcardesign m-0" style={{ height: "auto" }}>
                          <div className="avatarimg">
                            <img src={state?.avatar} referrerPolicy={"no-referrer"} alt="" />
                          </div>
                        </div>
                      ) : (
                        <div className="usercardesign m-0" style={{ height: "auto" }}>
                          <div className="initials-placeholder">placeholder.toUpperCase()</div>
                        </div>
                      )}
                    </>
                  )}
                  <h4 className="group-user-name m-0">
                    {loading ? <Skeleton count={1} width="10vw" /> : <> {state?.name || ""} </>}
                  </h4>
                </div>
              </div>
              <div className="col-md-7">
                <div className="dashstatdata">
                  {type === "visits" && (
                    <>
                      <div className="welcometext">
                        <p>{loading ? <Skeleton width="5vw" /> : <> Total Visits </>}</p>
                        {loading ? <Skeleton width="5vw" /> : <h4>{totalPages}</h4>}
                      </div>
                      <div className="welcometext ">
                        <p>{loading ? <Skeleton width="5vw" /> : <> Total Time Spent </>} </p>
                        {loading ? <Skeleton width="5vw" /> : <h4>{totalTimeSpent}</h4>}
                      </div>
                    </>
                  )}
                  {type === "session" && (
                    <>
                      <div className="welcometext">
                        <p>{loading ? <Skeleton width="5vw" /> : <> Total Visits </>}</p>
                        {loading ? <Skeleton width="5vw" /> : <h4>{totalPages}</h4>}
                      </div>
                      <div className="welcometext ">
                        <p>{loading ? <Skeleton width="5vw" /> : <> Average Time Spent </>} </p>
                        {loading ? <Skeleton width="5vw" /> : <h4>{averageTimeSpent}</h4>}
                      </div>
                      <div className="welcometext ">
                        <p>{loading ? <Skeleton width="5vw" /> : <> Total Time Spent </>} </p>
                        {loading ? <Skeleton width="5vw" /> : <h4>{totalTimeSpent}</h4>}
                      </div>
                    </>
                  )}
                  {type === "eventsList" && (
                    <>
                      <div className="welcometext">
                        <p>{loading ? <Skeleton width="5vw" /> : <> Total Events </>}</p>
                        {loading ? <Skeleton width="5vw" /> : <h4>{totalEvents}</h4>}
                      </div>
                      <div className="welcometext ">
                        <p>{loading ? <Skeleton width="5vw" /> : <> Total Time Spent </>} </p>
                        {loading ? <Skeleton width="5vw" /> : <h4>{totalEventTimeSpent}</h4>}
                      </div>
                    </>
                  )}
                  {type === "eventDuration" && (
                    <>
                      <div className="welcometext">
                        <p>{loading ? <Skeleton width="5vw" /> : <> Total Events </>}</p>
                        {loading ? <Skeleton width="5vw" /> : <h4>{totalEvents}</h4>}
                      </div>
                      <div className="welcometext ">
                        <p>{loading ? <Skeleton width="5vw" /> : <> Average Time Spent </>} </p>
                        {loading ? <Skeleton width="5vw" /> : <h4>{humanReadable(averageEventTimeSpent)}</h4>}
                      </div>
                      <div className="welcometext ">
                        <p>{loading ? <Skeleton width="5vw" /> : <> Total Time Spent </>} </p>
                        {loading ? <Skeleton width="5vw" /> : <h4>{totalEventTimeSpent}</h4>}
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container-fluid px-0">
          <UserEngagementTable
            type={type}
            list={list}
            loading={loading}
            setPage={setPage}
            page={page}
            limit={limit}
            pageCount={totalPages}
            sortBy={sortBy}
            setSortBy={setSortBy}
          />
        </div>
      </div>
    </>
  );
};
export default UserEngagement;
